export class ErreurMessages {
  public champObligatoire = 'error.required';
  public aCorriger = 'error.a_corriger';
  public nbErreurCorriger = 'error.nb_erreur_corriger';
  public libelle = 'error.libelle';
  public formatMailInvalide = 'error.format_mail_invalide';
  public selectionnerValeur = 'error.selectionner_valeur';
  public cocherCase = 'error.cocher_case';
  public minCaractere = 'error.min_caractere';
  public maxCaractere = 'error.max_caractere';
  public minTextLength = 'error.min_caractere'; /*PRB0053517: ajouter le message par défaut de la nouvelle erreur*/
  public fichierMaximum = 'error.fichier_maximum';
  public fichierVolumineux = 'error.fichier_volumineux';
  public max = 'error.max';
  public min = 'error.min';
  public pattern = 'error.pattern';
  public erreurByStep = 'error.erreur_by_step';
  public erreursByStep = 'error.erreurs_by_step';
  public warningByStep = 'error.warning_by_step';
  public warningsByStep = 'error.warnings_by_step';

  public pattern_eform = 'error.pattern_eform';
  public invalidReferenceValue = 'error.invalid_reference_value';
  constructor() {
  }
}
